import { useEffect, useRef } from 'react';

import {
  defaultGroupings,
  defaultMetrics,
} from '../../app/providers/redux/slices/reports/table/tableSlice';
import MainLayout from '../../shared/common/components/layouts/MainLayout';
import Loader from '../../shared/common/components/loader/Loader';
import ReportChart from '../../shared/common/components/reports/chart/ReportChart';
import CreateMetricsModal from '../../shared/common/components/reports/CreateMetricsModal';
import FirstRegIcon from '../../shared/common/components/reports/params/attribution/icons/FirstRegIcon';
import LastRegIcon from '../../shared/common/components/reports/params/attribution/icons/LastRegIcon';
import TypeIcon from '../../shared/common/components/reports/params/attribution/icons/TypeIcon';
import Params from '../../shared/common/components/reports/params/Params';
import ReportTable from '../../shared/common/components/reports/report-table';
import UniversalReportTitle from '../../shared/common/components/reports/un-title/UniversalReportTitle';
import { chartDetails } from '../../shared/common/constants/details';
import { useActions } from '../../shared/common/hooks/useActions';
import { useReportPageInit } from '../../shared/common/hooks/useReportPageInit';
import { useTypedSelector } from '../../shared/common/hooks/useTypedSelector';

const attrItems = [
  {
    id: 'type_applications',
    name: 'Тип регистрации:',
    selectValues: [
      { name: 'Нулевые заказы GC', id: '2', icon: null },
      { name: 'Прямая продажа', id: '4', icon: null },
      { name: 'Регистрации GC', id: '0', icon: null },
      { name: 'SCAN', id: '1', icon: null },
      //{ name: "Ручное добавление", id: "3", icon: null },
    ],
    description: `Выбор типа регистрации по которым нужно создать отчёт:
                <br><br>
                Типы регистраци:
                <br><br>
                - SCAN - Это данные собираемые скриптом SCAN с форм;<br>
                - Прямая продажа - эта регистрация создаётся автоматически в SCANе при создании платного заказа. Название регистрации будет являться название платного предложения;<br>
                - Нулевые заказы GC - Заказы в GetCourse со стоимостью 0 руб.;<br>
                - Регистрации GC -  Первая регистрация (попадания в базу) в GetCourse;<br>
                <br><br>
                <a href="https://doc.scananalytics.ru/otchety/tip-registracii/" rel="noopener noreferrer" target="_blank">Подробнее</a>.
                `,
    icon: <TypeIcon />,
  },
  {
    id: 'attribution',
    name: 'Атрибуция:',
    selectValues: [
      { name: 'Первая регистрация', id: '1', icon: <FirstRegIcon /> },
      { name: 'Последняя регистрация', id: '2', icon: <LastRegIcon /> },
    ],
    description: `Сервис SCAN позволяет определить к какой регистрации пользователя привязывать заказ. В сервисе 2 типа атрибуции:
                <br><br>
                - Первая регистрация <br>
                - Последняя регистрация <br>
                <br><br>
                <a href="https://doc.scananalytics.ru/otchety/atribuciya/" rel="noopener noreferrer" target="_blank">Подробнее</a>.
                `,
    icon: null,
  },
];

const Home = () => {
  const isMountRef = useRef(true);

  // Используем универсальный хук для инициализации страницы отчёта
  // Передаём дефолтные метрики и группировки для отчёта по регистрациям
  const { isChartLoading } = useReportPageInit({
    defaultMetrics: defaultMetrics.filter(Boolean) as any[],
    defaultGroupings: defaultGroupings.filter(Boolean) as any[],
  });

  useEffect(() => {
    document.body.style.overflow = 'scroll';
    document.body.style.overflowX = 'auto';

    return () => {
      document.body.style.overflow = '';
      document.body.style.overflowX = '';
    };
  }, []);

  const { isCreateMetricsVisible } = useTypedSelector((state) => state.reports);
  const { selectedSchool } = useTypedSelector((state) => state.currentSchool);
  const { getCustomGroups } = useActions();

  // Загружаем список «Групп регистраций» при входе на страницу (до открытия окна группировок),
  // чтобы имена выбранных custom_group_* корректно резолвились при открытии сохранённого отчёта.
  useEffect(() => {
    if (selectedSchool?.id) {
      getCustomGroups(selectedSchool.id, window.location.pathname, undefined, false);
    }
  }, [ selectedSchool?.id ]);

  return (
    <>
      <MainLayout pageTitle="Главная">
        <div className="page-wrapper">
          <div className="page-content">
            <UniversalReportTitle />
            <Params
              attributionItems={attrItems}
              detailsItems={chartDetails}
              filtersFilter={[
                'Пользователи',
                'Регистрации',
                'Заявки',
                'Заказы',
                'Платежи',
                'Вебинары',
                'Посещение страницы',
              ]}
              isMountReportRef={isMountRef}
            />
            <Loader loading={isChartLoading}>
              <ReportChart reportType="registration" />
            </Loader>
            <ReportTable reportType="universal" />
          </div>
        </div>
      </MainLayout>

      {isCreateMetricsVisible && (
        <CreateMetricsModal title="Создание метрики в отчете по регистрациям" />
      )}
    </>
  );
};

export default Home;
